<template>
    <Head title="Extrato de Pontos" />
    <Authenticated>
        <div
            class="grid modal-show fixed bg-gray-600 bg-opacity-80 top-0 left-0 items-center justify-center w-screen h-screen"
            :class="{ hidden: isAddClass }"
        >
            <div class="grid rounded-2xl p-4 items-center bg-white w-[20.8rem]">
                <div>
                    <div class="relative">
                        <h1 class="font-bold text-primary text-center">
                            Filtro
                        </h1>
                        <button
                            class="absolute top-0 right-0 font-semibold text-primary"
                            v-on:click="RemoveClass"
                        >
                            x
                        </button>

                        <a
                            href="javascript:void(0) "
                            class="absolute top-0 left-0 text-blue-500 hover:underline text-xs"
                            :class="{ hidden: isAddClassVoltar }"
                            v-on:click="RemoveClassVoltar"
                        >
                            Voltar
                        </a>
                    </div>

                    <div :class="{ hidden: isAddClassPeriodoData }">
                        <p class="pt-3 pb-3 font-bold text-gray-500">Data</p>
                        <ul class="flex flex-wrap gap-2">
                            <li
                                v-for="(filter, key) in [7, 15, 30, 60]"
                                :key="key"
                            >
                                <a
                                    @click="setFilterValueLessDays(filter)"
                                    class="border p-2 font-bold text-xs rounded table w-full text-center border-black hover:bg-gray-300 hover:border-gray-300 transition-all cursor-pointer"
                                    :class="
                                        filterLessDay == filter
                                            ? 'bg-gray-300 border-gray-300'
                                            : ''
                                    "
                                    >{{ filter }} Dias</a
                                >
                            </li>

                            <li class="table w-40 mt-1">
                                <a
                                    href="javascript:void(0)"
                                    class="border p-2 font-bold text-xs rounded table w-full text-center border-black hover:bg-gray-300 hover:border-gray-300 transition-all cursor-pointer"
                                    v-on:click="resetSetDate()"
                                    >Selecionar Periodo</a
                                >
                            </li>
                        </ul>

                        <p class="pt-3 pb-3 font-bold text-gray-500">
                            Lançamentos
                        </p>

                        <div class="grid gap-1">
                            <div>
                                <input
                                    type="radio"
                                    id="huey"
                                    name="drone"
                                    value="C"
                                    v-model="filter.currentType"
                                    checked
                                />
                                <label class="ml-2" for="huey">Entrada</label>
                            </div>

                            <div>
                                <input
                                    type="radio"
                                    id="dewey"
                                    name="drone"
                                    value="D"
                                    v-model="filter.currentType"
                                />
                                <label class="ml-2" for="dewey">Saída</label>
                            </div>
                        </div>

                        <ul class="grid grid-cols-2 gap-7 mt-4">
                            <li>
                                <a
                                    href=""
                                    class="grid font-bold text-primary text-center p-2 border-primary border rounded-2xl mb-2 hover:bg-gray-300"
                                >
                                    Limpar Filtros
                                </a>
                            </li>
                            <li>
                                <Button
                                @click.prevent="sendSpecificFilter"
                                class="bg-primary !text-white"
                                >
                                    Aplicar Filtros
                                </Button>
                            </li>
                        </ul>
                    </div>

                    <div :class="{ hidden: isAddClassVoltar }">
                        <p class="text-gray-500 font-bold mt-1">Data</p>
                        <ul class="grid gap-5 mt-1 grid-flow-col">
                            <li>
                                <label class="mb-1 mr-5 flex font-semibold">
                                    De:
                                </label>
                                <input
                                    @click="setInput('initialData')"
                                    v-model="initialData.data"
                                    @keyup="formatDate"
                                    type="text"
                                    placeholder="DD/MM/AAAA"
                                    class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 form-textarea bg-gray-100 border-gray-300"
                                />
                            </li>

                            <li>
                                <label class="mb-1 mr-5 flex font-semibold">
                                    Até:
                                </label>
                                <input
                                    @click="setInput('finalData')"
                                    v-model="finalData.data"
                                    @keyup="formatDate"
                                    type="text"
                                    placeholder="DD/MM/AAAA"
                                    class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 form-textarea bg-gray-100 border-300"
                                />
                            </li>
                        </ul>

                        <div class="calendar bg-gray-100 p-4 mt-8 rounded-2xl">
                            <div
                                class="header grid grid-cols-3 justify-items-center"
                            >
                                <button
                                    @click="prev"
                                    class="font-bold text-primary text-center"
                                >
                                    &lt;
                                </button>
                                <span
                                    class="font-bold text-primary text-center"
                                    >{{ title }}</span
                                >
                                <button
                                    @click="next"
                                    class="font-bold text-primary text-center"
                                >
                                    &gt;
                                </button>
                            </div>

                            <div
                                class="week grid grid-flow-col justify-items-center pt-2 pb-2"
                            >
                                <div class="day text-xs uppercase">Dom</div>
                                <div class="day text-xs uppercase">Seg</div>
                                <div class="day text-xs uppercase">Ter</div>
                                <div class="day text-xs uppercase">Qua</div>
                                <div class="day text-xs uppercase">Qui</div>
                                <div class="day text-xs uppercase">Sex</div>
                                <div class="day text-xs uppercase">Sab</div>
                            </div>

                            <div
                                class="week grid grid-cols-auto-calendar justify-items-center h-8 items-center text-sm"
                                v-for="(week, key) in weeks"
                                :key="key"
                            >
                                <!-- :class="day == '0' ? 'hide' : ''" -->
                                <div
                                    class="day selectable g cursor-pointer hover:bg-primary hover:text-white rounded-full p-2 py-1.5 min-w-[32px] text-center"
                                    :class="{ hide: isZero(day) }"
                                    v-for="(day, key) in week"
                                    :key="key"
                                    @click="setData(day, month, year, $event)"
                                >
                                    {{ day }}
                                </div>
                            </div>
                        </div>

                        <div class="grid justify-items-center mt-8">
                            <a
                                @click="sendSpecificFilter()"
                                href="javascript:void(0)"
                                class="font-semibold grid p-4 leading-normal bg-primary text-white rounded-2xl"
                                >Selecionar Datas</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Heading title="Extrato de Pontos" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div class="component-background-desktop min-h-[70vh]">
            <div class="px-2.5 py-[35px] xl:px-[15vw]">
                <div
                    class="border border-c p-4 grid border-primary max-w-[437px] mb-8 rounded-2xl bg-white"
                >
                    <p class="font-bold text-primary">Meus Créditos</p>
                    <p>Confira seu saldo de créditos</p>
                    <!-- <p>{{transactions.data}}</p> -->
                    <h2
                        class="py-14 w-full grid items-center justify-items-center my-5 bg-gray-100 text-primary text-shadeelected font-bold rounded-2xl text-3xl"
                        v-if="$page.props.auth.user.isVisibleBalance"
                    >
                        {{ account.data?.balance }} P$
                    </h2>
                    <h2
                        class="py-14 w-full grid items-center justify-items-center my-5 bg-gray-100 text-primary text-shadeelected font-bold rounded-2xl text-3xl"
                        v-else
                    >
                        **.** P$
                    </h2>
                    <a class="cursor-pointer" v-if="!$page.props.auth.user.isVisibleBalance" @click="handleVisibleBalance(true)" style="font-siza: 0.8rem">
                        Ver saldo
                    </a>

                    <a class="cursor-pointer" v-else @click="handleVisibleBalance(false)" style="font-siza: 0.8rem">
                        Ocultar saldo
                    </a>
                    <div class="xl:flex justify-between xl:items-end">
                        <!-- {{account}} -->
                        <p class="text-[10px] mb-2">
                            Última atualização:
                            {{
                                account
                                    ? formatUpdatedDate(account.data?.updatedAt)
                                    : getCurrentDate()
                            }}
                        </p>
                        <Button class="max-w-[146px] p-4 whitespace-nowrap">
                            <a
                                @click="openReconhece"
                            >
                                Resgate Agora
                            </a>
                        </Button>
                    </div>
                </div>

                <a
                    href="javascript:void(0)"
                    title="Filtrar"
                    class="border border-primary rounded-3xl text-primary bg-white p-2 flex items-center my-6 w-[5rem] text-right justify-between text-sm hover:bg-gray-200 hover:underline"
                    v-on:click="addClass"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14.23"
                        height="13.038"
                        viewBox="0 0 14.23 13.038"
                    >
                        <g
                            id="Grupo_10972"
                            data-name="Grupo 10972"
                            transform="translate(-2.385 -2.981)"
                        >
                            <path
                                id="Caminho_10267"
                                data-name="Caminho 10267"
                                d="M77.941,81.526H69.462a1.749,1.749,0,0,0-3.315,0H64.824a.557.557,0,0,0,0,1.113h1.323a1.749,1.749,0,0,0,3.315,0h8.478a.557.557,0,1,0,0-1.113ZM67.8,82.719a.636.636,0,1,1,.636-.636A.637.637,0,0,1,67.8,82.719Z"
                                transform="translate(-61.882 -77.353)"
                                fill="#0771c5"
                            />
                            <path
                                id="Caminho_10268"
                                data-name="Caminho 10268"
                                d="M77.941,210.059H76.617a1.749,1.749,0,0,0-3.315,0H64.824a.557.557,0,0,0,0,1.113H73.3a1.749,1.749,0,0,0,3.316,0h1.323a.557.557,0,1,0,0-1.113Zm-2.981,1.192a.636.636,0,1,1,.636-.636A.637.637,0,0,1,74.959,211.252Z"
                                transform="translate(-61.882 -201.116)"
                                fill="#0771c5"
                            />
                            <path
                                id="Caminho_10269"
                                data-name="Caminho 10269"
                                d="M77.941,338.592H71.847a1.749,1.749,0,0,0-3.315,0H64.824a.557.557,0,0,0,0,1.113h3.708a1.749,1.749,0,0,0,3.315,0h6.093a.557.557,0,1,0,0-1.113Zm-7.751,1.192a.636.636,0,1,1,.636-.636A.637.637,0,0,1,70.19,339.785Z"
                                transform="translate(-61.882 -324.879)"
                                fill="#0771c5"
                            />
                        </g>
                    </svg>
                    Filtrar
                </a>
                <TopicExtrato
                    v-for="(transaction, key) in transactions?.data"
                    :key="key"
                    :title="transaction.month"
                    :accordions="transaction"
                    class="w-full"
                />
            </div>
        </div>
        <transition>
            <div
                v-if="showModalChangePoints"
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-primary rounded-[4px] w-2.5/12 px-4 py-4 leading-9 flex flex-col gap-y-4"
                >
                    <button
                        class="self-end"
                        @click="showModalChangePoints = false"
                    >
                        <Icon name="Fechar" />
                    </button>
                    <img src="images/banner-troque-seus-pontos.jpeg" alt="" />
                </div>
            </div>
        </transition>
        <MFAModal v-if="isAuthorizeModalOpen"
            :credentialauthenticationmethods="credential.credentialauthenticationmethods"
            accessTo="reconhece"
            :showModal="isAuthorizeModalOpen"
            @onCancel="cancelAuthorizationModalEvent"
            @onSuccess="successAuthorizationModalEvent" />
    </Authenticated>
    <ModalReconheceDisabled :showModal="isFlaggedModalOpen" @closeModal="closeIsFlaggedModal" />
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import PagesLayout from "@/Layouts/Pages.vue";
import TopicExtrato from "@/Components/TopicExtrato.vue";
import AccordionExtratoPontos from "@/Components/UI/Modals/Accordion.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import { formatUpdatedDate, formatDate } from "@/Helpers/masks";
import moment from "moment";
import axios from "axios";
import ModalReconheceDisabled from "@/Components/UI/Modals/ModalReconheceDisabled.vue";
import MFAModal from "@/Components/MFA/Modal.vue";

const DATE = new Date();
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
];
const daysInYearMonth = (y, m) => new Date(y, m + 1, 0).getDate();

export default {
    components: {
        Authenticated,
        Head,
        Heading,
        Head,
        AccordionExtratoPontos,
        TopicExtrato,
        PagesLayout,
        Icon,
        Button,
        ModalReconheceDisabled,
        MFAModal,
    },

    props: {
        account: Object,
        transactions: Object,
        credential: Object,
        urlReconhece: String,
    },

    data() {
        return {
            isAuthorizeModalOpen: false,
            showModalChangePoints: false,
            title: "-",
            month: 0,
            year: 0,
            days: [],
            weeks: [],
            filterLessDay: "",
            initialData: {
                data: "",
                elSelected: "",
            },
            finalData: {
                data: "",
                elSelected: "",
            },
            currentInput: "",

            isAddClass: true,
            isAddClassVoltar: true,
            isAddClassPeriodoData: false,
            isAddClassPeriodoCalendar: false,

            filter: {
                currentType: "C",
            },
            isFlaggedModalOpen: false,
        };
    },

    mounted() {
        this.init();
    },

    methods: {
        closeAuthorizationModal() {
            this.isAuthorizeModalOpen = false;
        },
        openAuthorizationModal() {
            this.isAuthorizeModalOpen = true;
        },
        cancelAuthorizationModalEvent() {
            this.closeAuthorizationModal();
        },
        successAuthorizationModalEvent() {
            this.closeAuthorizationModal();

            setTimeout(() => {
                const urlReconhece= this.$page.props.auth.user.urlReconhece;
                return window.open(urlReconhece, '_blank');
            })
        },
        openReconhece() {
            if (this.canAccessReconhece()) {
                this.openAuthorizationModal();
            } else {
                this.openIsFlaggedModal();
            }
        },
        canAccessReconhece()
        {
            return !!!this.$page.props.auth.user.isFlagged;
        },
        openIsFlaggedModal() {
            this.isFlaggedModalOpen = true;
        },
        closeIsFlaggedModal() {
            this.isFlaggedModalOpen = false;
        },
        getCurrentDate: function () {
            return new moment().format("DD/MM/YYYY [às] HH:mm");
        },
        handleVisibleBalance: function (opt) {
            axios
                .post(route("my-profile-change-visible-balance"), {
                    isVisibleBalance: opt,
                })
                .then((response) => {
                    this.$page.props.auth.user.isVisibleBalance = opt;
                });
        },
        resetSetDate() {
            this.isAddClassPeriodoData = true;
            this.isAddClassVoltar = false;
            this.filterLessDay = "";

            if (this.initialData.elSelected) {
                this.initialData.elSelected?.classList.remove("bg-primary");
                this.initialData.elSelected?.classList.remove("text-white");
            }
            if (this.finalData.elSelected) {
                this.finalData.elSelected?.classList.remove("bg-primary");
                this.finalData.elSelected?.classList.remove("text-white");
            }

            this.initialData.data = "";
            this.initialData.elSelected = "";
            this.finalData.data = "";
            this.finalData.elSelected = "";
        },
        addClass: function () {
            this.isAddClass = false;
        },

        addClassVoltar: function () {
            this.isAddClassVoltar = false;
            this.isAddClassPeriodoData = true;
        },

        RemoveClassVoltar: function () {
            this.isAddClassVoltar = true;
            this.isAddClassPeriodoData = false;
        },

        RemoveClass: function () {
            this.isAddClass = true;
            this.isAddClassVoltar = true;
            this.isAddClassPeriodoData = false;
        },

        isZero(value) {
            if (value == 0) {
                return true;
            }
        },
        getData(day, month, year) {
            if (day < 10) {
                day = `0${day.toString()}`;
            }
            if (month + 1 < 10) {
                month = `0${(month + 1).toString()}`;
            } else {
                month = month + 1;
            }
            return `${day}${month}${year}`;
        },

        setInput(input) {
            this.currentInput = input;
            console.log(this.currentInput);
        },

        setData(day, month, year, el) {
            let data = this.formatData(this.getData(day, month, year));

            if (this.currentInput == "initialData") {
                if (this.initialData.elSelected) {
                    this.initialData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.initialData.elSelected = el.target;
                this.initialData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.initialData.data = data;
            }
            if (this.currentInput == "finalData") {
                if (this.finalData.elSelected) {
                    this.finalData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.finalData.elSelected = el.target;
                this.finalData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.finalData.data = data;
            }
        },

        formatData(data) {
            let value = data;

            value = value.replace(/\D/g, "");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");

            value = value.replace(/(\d{2})(\d{2})$/, "$1$2");

            return value.substr(0, 10);
        },

        next() {
            this.update(new Date(this.year, this.month + 1, 1));
        },
        prev() {
            this.update(new Date(this.year, this.month - 1, 1));
        },
        daysInMonth() {
            return daysInYearMonth(this.year, this.month);
        },
        monthStartsOn() {
            return new Date(this.year, this.month, 1).getDay();
        },
        setTitle() {
            this.title = `${MONTHS[this.month]} ${this.year}`;
        },
        update(date) {
            if (date) {
                this.month = date.getMonth();
                this.year = date.getFullYear();
                this.day = date.getDate();
            }
            this.setTitle();
            this.setDays();
            this.setWeeks();
        },
        setDays() {
            let preDays =
                this.monthStartsOn() > 0
                    ? Array(this.monthStartsOn()).fill(0)
                    : [];
            const rawDays = [...Array(this.daysInMonth()).keys()];
            this.days = [...preDays, ...rawDays.map((item) => item + 1)];
        },
        setWeeks() {
            let n = 0;
            this.weeks = [];

            while (n < this.days.length) {
                let week = [
                    ...this.days.slice(n, (n += 7)),
                    ...Array(7).fill(0),
                ].slice(0, 7);
                this.weeks.push(week);
            }
        },
        showEvents(day) {
            alert(day);
        },
        init() {
            this.update(DATE);
        },
        formatUpdatedDate,
        formatDate,

        setFilterValueLessDays(days) {
            let dateOffset = 24 * 60 * 60 * 1000 * days;
            let dataAtual = new Date();
            this.filterLessDay = days;

            let initialDate = new Date(dataAtual.getTime() - dateOffset);

            this.initialData.data = `${initialDate.getDate()}/${
                initialDate.getMonth() + 1
            }/${initialDate.getFullYear()}`;
            this.finalData.data = `${dataAtual.getDate()}/${
                dataAtual.getMonth() + 1
            }/${dataAtual.getFullYear()}`;
            // this.filterTransactions(initialDateFormated, currentDateFormated)
            // console.log(initialDateFormated, currentDateFormated);
        },
        formatFilterDate(data) {
            let dia = data.getDate();
            let mes = data.getMonth();
            let ano = data.getFullYear();

            return `${ano}-${mes + 1}-${dia}`;
        },

        sendSpecificFilter() {
            let initialArrayData = this.initialData.data.split("/");
            let objectInitialData = new Date(
                initialArrayData[2],
                initialArrayData[1] - 1,
                initialArrayData[0]
            );

            let finalArrayData = this.finalData.data.split("/");
            let objectFinalData = new Date(
                finalArrayData[2],
                finalArrayData[1] - 1,
                finalArrayData[0]
            );

            if (
                this.checarData(objectInitialData) &&
                this.checarData(objectFinalData)
            ) {
                let initialDateFormated =
                    this.formatFilterDate(objectInitialData);
                let finalDataFormated = this.formatFilterDate(objectFinalData);

                this.filterTransactions(
                    initialDateFormated,
                    finalDataFormated,
                    this.filter.currentType
                );
            }
        },
        checarData(data) {
            return data instanceof Date && !isNaN(data);
        },
        filterTransactions(dataInicial, dataFinal, type) {
            // return console.log(dataInicial, dataFinal, type);
            this.$inertia.post(
                "extrato-de-pontos",
                {
                    dataInicial: dataInicial,
                    dataFinal: dataFinal,
                    tipoDeTransacao: type,
                },
                {
                    onSuccess: this.RemoveClass(),
                }
            );
        },
    },
};
</script>
